// extracted by mini-css-extract-plugin
export default {"containerBox":"EdofCrative_containerBox__wFozq","container":"EdofCrative_container__F6G4Q","smartImage":"EdofCrative_smartImage__dQK7v"};